import { EventBus } from '../../../../core/shared/helpers/EventHelper';
import ListComponent from '../../../../core/infraestructure/ListComponent';
import CourseCategoryViewModel from '../../../../core/features/setting/viewmodels/CourseCategoryViewModel';

export default {
  extends: ListComponent,
  data() {
    return {
      modulePermissions: 'Settings-CourseCategories',
      item: null,
      searchName: null,
      searchCode: null,
      viewModel: null,
      parentFilter: '',
      parents: [],
      modalImport: {
        isVisible: false,
        isLoading: false,
        title: 'IMPORTAR CATEGORIAS DE CURSOS',
        onUploadImport: 'onUploadImportCourseCategory',
        onCancelImport: 'onCancelImportCourseCategory',
      },
    };
  },
  mounted() {
    EventBus.$on('onSubmitedCourseCategory', this.onSearch);
    EventBus.$on('onUploadImportCourseCategory', this.onUploadImport);
    EventBus.$on('onCancelImportCourseCategory', this.onCancelImport);
  },
  beforeDestroy() {
    EventBus.$off('onSubmitedCourseCategory', this.onSearch);
    EventBus.$off('onUploadImportCourseCategory', this.onUploadImport);
    EventBus.$off('onCancelImportCourseCategory', this.onCancelImport);
  },
  created() {
    this.viewModel = new CourseCategoryViewModel(this);
    this.onActive();
  },
  methods: {
    onActive() {
      this.onSearch();
    },
    onAllFilterChange(data, field) {
      this.onFilterChange(data, field);
    },
    onSearchCourseCategory(data) {
      if (data) {
        this.viewModel.findCourseCategories(`Name=${data}`)
    } else {
        this.parents = []
    }
    },
    onSearchCourseCategoriesResponse(response) {
      this.parents = response;
    },
    onFocusCourseCategory() {
      this.$forceUpdate()
    },
    onShowImport() {
      this.viewModel.showModal(this.modalImport, true);
    },
    onUploadImport(file){
      this.viewModel.showModalLoading(this.modalImport, true);
      this.viewModel.import(file);
    },
    onCancelImport(){
      this.viewModel.showModal(this.modalImport, false);
    },
    onExportToExcel() {
      this.viewModel.exportToExcel();
    },
    onCanCreate() {
      return this.canCreate(this.modulePermissions)
    },
    onCanRead() {
      return this.canRead(this.modulePermissions)
    },
    onCanUpdate() {
      return this.canUpdate(this.modulePermissions)
    },
    onCanDelete() {
      return this.canDelete(this.modulePermissions)
    },
  },
  computed: {}
}